/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import {platformJsonFilter} from '../../../pages/orgManager/Utils/OrgProfile/Forms/Constants/Common';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';

const OPCategory = async (): Promise<any> => {
  const category = useJSONStore.getState().category;
  const token = useUserStore.getState().userToken;
  const setCategory = useJSONStore.getState().setCategory;

  if (category.length === 0) {
    await axios
      .request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.JSON.category}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data: {}
      })
      .then((res) => {
        setCategory(platformJsonFilter(res.data.data));
      })
      .catch((err) => {
        return err.message;
      });
  }
};

export default OPCategory;
